var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74121 20.0071L9.3283 14.42C9.75275 13.9956 10.3284 13.7571 10.9287 13.7571C11.529 13.7571 12.1047 13.9956 12.5291 14.42L17.4912 19.3821M17.4912 19.3821L19.3662 21.2571M17.4912 19.3821L19.9533 16.92C20.3777 16.4956 20.9535 16.2571 21.5537 16.2571C22.154 16.2571 22.7297 16.4956 23.1541 16.92L26.2412 20.0071",
    stroke: "#1E1F26",
    strokeWidth: 1.13636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3662 10.0002C19.7113 10.0002 19.9912 9.72042 19.9912 9.37524C19.9912 9.03007 19.7113 8.75024 19.3662 8.75024M19.3662 10.0002C19.0211 10.0002 18.7412 9.72042 18.7412 9.37524C18.7412 9.03007 19.0211 8.75024 19.3662 8.75024M19.3662 10.0002V8.75024",
    stroke: "#1E1F26",
    strokeWidth: 1.13636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61367 24.6842C3.11621 22.931 3.11621 20.2874 3.11621 15.0002C3.11621 9.71308 3.11621 7.06949 4.61367 5.31619C4.82631 5.06722 5.05819 4.83534 5.30716 4.62271C7.06046 3.12524 9.70405 3.12524 14.9912 3.12524C20.2783 3.12524 22.922 3.12524 24.6752 4.62271C24.9242 4.83534 25.1561 5.06722 25.3687 5.31619C26.8662 7.06949 26.8662 9.71308 26.8662 15.0002C26.8662 20.2874 26.8662 22.931 25.3687 24.6842C25.1561 24.9332 24.9242 25.1651 24.6752 25.3777C22.922 26.8752 20.2783 26.8752 14.9912 26.8752C9.70405 26.8752 7.06046 26.8752 5.30716 25.3777C5.05819 25.1651 4.82631 24.9332 4.61367 24.6842Z",
    stroke: "#1E1F26",
    strokeWidth: 1.13636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.cac842e3ebb643378ef3b6deb5e90bd1.svg";
export { ForwardRef as ReactComponent };